export enum tipoVitrine {
    PRODUTOS_BLACK_FRIDAY = 2,
    VITRINE_LANDING_PAGE = 3,
    MOSTRUARIO_OFERTA_LIMITADA = 4,
    MOSTRUARIO_TRES_PRODUTOS = 5,
    MOSTRUARIO_TRES_LINHA = 6,
    MOSTRUARIO_TRES_LINHA_TIMER = 8,
    UM_DESTAQUE_TRES_MINIATURA = 9,
    UM_DESTAQUE_TRES_MINIATURA_BLACK = 10,
    QUATRO_ITENS_BLACK = 11,
    UM_ITEM_DESTAQUE_BLACK = 12
}
